import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const fetchTeam = () => (cache ||= api.get("/team").then((r) => r.data.members).catch(() => { cache = null; return []; }));

export const CoachSelect = ({ value, onChange, testId = "coach-select", compact, label }) => {
  const [members, setMembers] = useState([]);
  useEffect(() => { fetchTeam().then(setMembers); }, []);
  if (members.length < 2) return null;
  const sel = (
    <select value={value || ""} onChange={(e) => onChange(e.target.value || null)} data-testid={testId} className={compact ? "coach-select" : ""}>
      <option value="">{compact ? "Assign coach…" : "Default (you)"}</option>
      {members.map((m) => <option key={m.id} value={m.id}>{m.name}{m.isOwner ? " · owner" : ""}</option>)}
    </select>
  );
  return label ? <div className="coach-field"><label>{label}</label>{sel}</div> : sel;
};
